export default __webpack_public_path__ + "699ff66d62623f111011b5456ff85bd3.png";